<template>
    <ion-card
        class="c-contract-card ion-margin-vertical u-select-text"
        :button="canPresentContractSwitcherModal"
        @click="presentContractSwitcherModal()"
    >
        <ion-grid v-if="Object.keys(contract).length > 0">
            <ion-row>
                <ion-col>
                    <h1>{{ contract.Name }}</h1>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <div>{{ allgemeinConfig.ContractIdFormatted }}</div>
                    <!-- Vertragsnummer<br> -->
                    <b>{{ contract.ContractIdFormatted }}</b
                    >&nbsp;<ion-icon
                        name="arrow-dropdown"
                        class="c-contract-card__dropdown"
                        v-if="canPresentContractSwitcherModal"
                    ></ion-icon>
                </ion-col>
                <ion-col
                    v-if="
                        allgemeinConfig.ContractIdFormatted != 'Polizzennummer'
                    "
                >
                    <div>Saldo</div>
                    <b>{{ contract.Balance | currency }}</b>
                </ion-col>
                <ion-col v-else-if="vorsorgeValue !== ''">
                    <div>Aktueller Wert</div>
                    <b>{{ vorsorgeValue | currency }}</b>
                </ion-col>
            </ion-row>
            <!-- <ion-row>
        <ion-col>
          <ion-icon name="download"></ion-icon>&nbsp;herunterladen
        </ion-col>
      </ion-row> -->
        </ion-grid>

        <ion-grid v-else>
            <ion-row>
                <ion-col>
                    <h1>
                        <ion-skeleton-text
                            animated
                            style="width: 50%;"
                        ></ion-skeleton-text>
                    </h1>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <div>
                        <ion-skeleton-text
                            animated
                            style="width: 100%;"
                        ></ion-skeleton-text>
                    </div>
                    <b>
                        <ion-skeleton-text
                            animated
                            style="width: 90%;"
                        ></ion-skeleton-text>
                    </b>
                </ion-col>
                <ion-col>
                    <div></div>
                    <ion-skeleton-text
                        animated
                        style="width: 100%;"
                    ></ion-skeleton-text>
                    <b>
                        <ion-skeleton-text
                            animated
                            style="width: 90%;"
                        ></ion-skeleton-text>
                    </b>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>
</template>

<script>
import ContractSwitcherModal from "@/components/ContractSwitcherModal";

export default {
    props: {
        contractId: {
            required: true,
            type: String,
        },
        feature: {
            required: false,
            type: String,
            default: "",
        },
        shouldPresentContractSwitcherModal: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    watch: {
        shouldPresentContractSwitcherModal(val) {
            if (val) {
                this.presentContractSwitcherModal();
            }
        },
    },
    mounted() {
        if (this.shouldPresentContractSwitcherModal) {
            this.presentContractSwitcherModal();
        }
        //   if (this.$store.state.contracts[this.contractId].Sparte === undefined) {
        //     this.$store.dispatch(
        //       "contractsDetails/getContractDetails",
        //       this.contractId
        //     );
        //   }
    },
    methods: {
        presentContractSwitcherModal() {
            if (this.canPresentContractSwitcherModal) {
                this.$ionic.modalController
                    .create({
                        component: ContractSwitcherModal,
                        componentProps: {
                            propsData: {
                                contractId: this.contractId,
                                feature: this.feature,
                            },
                            parent: this,
                        },
                    })
                    .then((m) => m.present());
            }
            // let radioInputs = [];
            // const contracts = this.$store.state.contracts;
            // for (let key in contracts) {
            //   if ("Unwetter" in contracts[key].Features) {
            //     let radioInput = {
            //       type: "radio",
            //       label:
            //         contracts[key].Name + ": " + contracts[key].ContractIdFormatted,
            //       value: contracts[key].ContractId
            //     };
            //     if (contracts[key].ContractId === this.contractId) {
            //       radioInput.checked = true;
            //     }
            //     radioInputs.push(radioInput);
            //   }
            // }
            // return this.$ionic.alertController
            //   .create({
            //     header: "Radio",
            //     inputs: radioInputs,
            //     buttons: [
            //       {
            //         text: "Abbrechen",
            //         role: "cancel"
            //       },
            //       {
            //         text: "Ok",
            //         handler: data => {
            //           console.log(data);
            //         }
            //       }
            //     ]
            //   })
            //   .then(a => a.present());
        },
    },
    computed: {
        canPresentContractSwitcherModal() {
            return (this.$store.state.unwetterwarnungen.contractsCounter > 1 &&
                (this.$route.name === "services-unwetterwarnung" ||
                    this.$route.name === "unwetterwarnung")) ||
                (this.$store.state.biketrax.contractsCounter > 1 &&
                    (this.$route.name === "services-biketrax" ||
                        this.$route.name === "biketrax")) ||
                (this.$store.getters.schadensmeldungen[this.feature] &&
                    this.$store.getters.schadensmeldungen[this.feature].length >
                        1)
                ? true
                : false;
        },
        allgemeinConfig() {
            let result = {};
            // console.log("xxxxx");
            // console.log(this.$store.state.contracts);
            if (this.contractId in this.$store.state.contracts) {
                // console.log("xxxx");
                // console.log(this.$store.state.contracts[this.contractId]);

                // if (this.$store.state.contracts != undefined) {

                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].allgemein;
            }

            return result;
        },
        contract() {
            let result = {};
            if (this.contractId in this.$store.state.contracts) {
                result = this.$store.state.contracts[this.contractId];
            }
            return result;
        },
        features() {
            let result = {};
            if (
                this.contractId in this.$store.state.contracts &&
                "Features" in this.$store.state.contracts[this.contractId]
            ) {
                result = this.$store.state.contracts[this.contractId].Features;
            }
            return result;
        },
        vorsorgeValue() {
            let result = "";
            if (
                "FlexibleLife" in this.features &&
                this.$store.state.flexiblelife.all[this.contractId] &&
                this.$store.state.flexiblelife.all[this.contractId].gesamtwert
            ) {
                result = this.$store.state.flexiblelife.all[this.contractId]
                    .gesamtwert;
            } else if (
                "Vollwert" in this.features &&
                this.$store.state.vollwert.all[this.contractId] &&
                this.$store.state.vollwert.all[this.contractId].wert
            ) {
                result = this.$store.state.vollwert.all[this.contractId].wert;
            }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.md {
    .c-contract-card {
        &__dropdown {
            position: absolute;
            font-size: 19px;
            top: 17px;
        }
    }
}

.ios {
    .c-contract-card {
        &__dropdown {
            position: absolute;
            font-size: 15px;
            top: 19px;
        }
    }
}
</style>
